import Link from 'next/link';
// @mui
import { BoxProps } from '@mui/material';
import SvgIconStyle from './SvgIconStyle';
// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const logo = (
    <SvgIconStyle
      src="/icons/ic_logo.svg"
      sx={{
        width: '155px',
        height: '28px',
        backgroundColor: 'common.white',
        ...sx,
      }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <Link href="/">{logo}</Link>;
}
